import { render, staticRenderFns } from "./PackageRow.vue?vue&type=template&id=88d4d710&scoped=true"
import script from "./PackageRow.vue?vue&type=script&lang=js"
export * from "./PackageRow.vue?vue&type=script&lang=js"
import style0 from "./PackageRow.vue?vue&type=style&index=0&id=88d4d710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d4d710",
  null
  
)

export default component.exports